module.exports = __webpack_public_path__ + "static/media/spain.dd9783be.png";